import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Track SPA page views in PostHog on every React Router navigation.
 * PostHog's auto capture_pageview only fires on initial page load.
 */
export function usePageView() {
  const location = useLocation();

  useEffect(() => {
    // Skip the initial load — PostHog auto-captures that via capture_pageview: true
    // Only track subsequent client-side navigations
    window.posthog?.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search]);
}
